import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import api from '@/shared/api';
import config from '@/config';
import MultiSelect, {
  removeItem as removeMultiSelectItem,
  addItem as addMultiSelectItem,
  splitItems as splitMultiSelectItems,
} from '@/shared/components/input/multiselect/MultiSelect';

const EmployeeTagMultiSelect = ({ value, onChange, placeholder, idProp, caseSensitive = true }) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.base.get(`${config.appUrls.api}/api/employee/tags`).then(({ data }) => {
      const newItems = (data || []).map(x => ({
        ...x,
        label: x.name,
      }));
      setItems(newItems);
    });
  }, []);

  if (!items) return null;

  const [selectedItems, availableItems] = splitMultiSelectItems(
    items,
    value,
    idProp,
    caseSensitive,
  );

  return (
    <MultiSelect
      selectedItem={selectedItems}
      onItemRemoved={item => onChange(removeMultiSelectItem(value, item, idProp, caseSensitive))}
      onItemSelected={item => onChange(addMultiSelectItem(value, item, idProp, caseSensitive))}
      items={availableItems}
      placeholder={placeholder}
      onCreateItem={undefined}
    />
  );
};
EmployeeTagMultiSelect.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  allowNew: PropTypes.bool,
  caseSensitive: PropTypes.bool,
  idProp: PropTypes.string,
};

EmployeeTagMultiSelect.defaultProps = {
  value: [],
  placeholder: undefined,
  allowNew: false,
  caseSensitive: true,
  idProp: 'id',
};

export default EmployeeTagMultiSelect;
